import { getField, updateField } from 'vuex-map-fields'
import api from '@/services/api'
import Artyom from 'artyom.js'
import validarBrowser from '@/mixins/validarBrowser'

const artyom = validarBrowser('chrome') ? new Artyom() : undefined

const inserirTexto = (state) => {
  let { texto } = state
  state.paragrafoMaiusculo = false

  const transformacoes = [
    iniciarEmMaiusculo,
    porX,
    cubicoQuadrado,
    texto => dicionario(texto, state.dicionario),
    texto => replaces(texto, state),
    ajusteVirgula
  ]

  const textoTransformado = transformacoes.reduce((texto, transformacao) => transformacao(texto), texto)

  formatarTexto(state.editor.editor, textoTransformado)
}

const dicionario = (texto, dicionario) => {
  return dicionario.reduce((acc, replace) => {
    const regex = new RegExp(replace.ds_chave, 'gmi')
    return acc.replace(regex, replace.ds_valor)
  }, texto)
}

const replaces = {
  novaLinha: [/(( ?inserir linha ?)|( ?nova linha ?)|( ?\n(\r)? ?))/gmi, '\v'],
  interrogacao: [/( ?interroga(c|ç){1}(a|ã){1}o ?)/gmi, '? '],
  exclamacao: [/( ?exclama(c|ç){1}(a|ã){1}o ?)/gmi, '! '],
  ponto: [/(( ?ponto ?)|( ?\. ?))/gmi, '. '],
  paragrafo: [/( ?(par(a|á){1}grafos? ?)|( ?(par(a|á){1}grafos? ?)))/gmi, '\v\v'],
  virgula: [/(( ?v(i|í)rgula ?)|( ?, ?))/gmi, ', '],
  traco: [/((tra(c|ç)o)|(h(i|í)fen))/gmi, '-']
}
/*
const exclusoes = ['virgula', 'traco']

const replaceText = (texto, state) => {
  texto = texto.trimEnd()

  Object.entries(replaces).forEach(([key, replace]) => {
    const [regex, replacement] = replace
    const matches = [...texto.matchAll(regex)]

    matches.forEach(match => {
      const arrayFrases = texto.split(match[0])
      let fraseFinal = ''

      arrayFrases.forEach((frase, index) => {
        let fraseTemp = ''
        let ignorar = exclusoes.some(r => match[0].match(replaces[r][0]))

        if (!ignorar) {
          fraseTemp = match[0].trim() + ` ${iniciarEmMaiusculo(frase.trimStart())}`
          state.paragrafoMaiusculo = true
        } else {
          fraseTemp = match[0].trim() + ` ${frase.trimStart()}`
        }

        fraseFinal += index === 0 ? frase : fraseTemp
      })

      texto = fraseFinal
    })

    texto = texto.replace(regex, replacement)
  })

  return texto.replace(/(\.{2})/gmi, '.')
    .replace(/(c\*{4})/gmi, 'corno')
}
*/

const formatarTexto = (editor, texto) => {
  const estilos = {
    negrito: { regex: /( ?negritos? ?)/gmi, toggle: () => editor.toggleBold() },
    italico: { regex: /( ?it(a|á){1}lico ?)/gmi, toggle: () => editor.toggleItalic() },
    sublinhado: { regex: /( ?sublinhado ?)/gmi, toggle: () => editor.toggleUnderline('Single') }
  }

  let entradas = 0

  Object.entries(estilos).forEach(([estilo]) => {
    const matches = [...texto.matchAll(estilo.regex)]

    matches.forEach(match => {
      entradas++

      const arrayFrases = texto.split(match[0])
      arrayFrases.forEach((frase, index) => {
        frase = ` ${frase.replace(estilo.regex, ' ')}`

        if (index !== 0) {
          estilo.toggle()
        }

        editor.insertText(frase)
      })

      texto = texto.replace(estilo.regex, ' ')
    })
  })

  if (entradas === 0) {
    editor.insertText(texto)
  }
}

const iniciarEmMaiusculo = (texto, paragrafoMaiusculo) => {
  return paragrafoMaiusculo && typeof texto === 'string'
    ? texto.trimStart().charAt(0).toUpperCase() + texto.trimStart().slice(1)
    : texto
}

const porX = (texto) => {
  return texto.replace(/([0-9.?,?] (por [0-9.?,?])+) ?(por)?/gmi, match => match.replace(/(por)/gmi, 'X'))
}

const ajusteVirgula = (texto) => {
  return texto.replace(/([0-9], [0-9]{1,})/gmi, match => match.replace(' ', ''))
}

const cubicoQuadrado = (texto) => {
  texto = texto.replace(/([0-9.?,?] ?((cm|cent(i|í)metros?) ?(c(u|ú)bicos?)))/gmi, (_, match) => texto.replace(match, 'cm³'))
  return texto.replace(/([0-9.?,?] ?((cm|cent(i|í)metros?) ?(quadrados?)))/gmi, (_, match) => texto.replace(match, 'cm²'))
}

export default {
  namespaced: true,
  state: {
    voz: artyom?.ArtyomWebkitSpeechRecognition,
    suporteReconhecimento: artyom?.speechSupported() !== undefined,
    editor: {},
    emExecucao: false,
    inicioPorAtalho: false,
    continuar: false,
    paragrafoMaiusculo: true,
    textoTemp: '',
    texto: '',
    frases: [],
    dicionario: []
  },
  getters: {
    getField
  },
  actions: {
    comandosVoz ({ dispatch, state }) {
      artyom.addCommands([
        /*
        {
          description: 'Dicionario',
          smart: true,
          indexes: ['auto-completar *', 'autocompletar *', ' autocompletar *', 'auto completar *', ' auto completar *',
            'Auto-completar *', 'Autocompletar *', 'Auto completar *'
          ],
          action: (i, wildcard) => {
            const tx = dicionario(wildcard.trim(), state.dicionario)
            state.editor.search.findAll(state.texto.trim())
            if (state.editor.searchModule.searchResults.length > 0) {
              state.editor.search.searchResults.replaceAll(tx)
              state.editor.selection.moveToParagraphEnd()
            }
          }
        },
        */
        {
          description: 'Autotexto',
          smart: true,
          indexes: ['auto-texto *', 'autotexto *', ' autotexto *', 'auto texto *', ' auto texto *',
            'Auto-texto *', 'Autotexto *', 'Auto texto *'
          ],
          action: (i, wildcard) => {
            state.editor.search.find(state.texto.trim())
            if (state.editor.searchModule.searchResults.length > 0) {
              dispatch('laudo/doLaudoFiltroTexto', wildcard.trim(), { root: true })
            }
          }
        }
      ])
    },
    doLaudoDicionario ({ commit, rootState }) {
      api().post('se1/doLaudoDicionario', { cd_medico: rootState.login.user.cd_medico }).then(response => {
        if (response.data.error || response.data[0]?.Falha) {
          commit('layout/SET_ALERTA', { mensagem: response.data.error || response.data[0]?.Falha }, { root: true })
        } else {
          commit('SET_DICIONARIO', response.data || [])
        }
      }).catch(e => {
        commit('layout/SET_ALERTA', { mensagem: e }, { root: true })
      })
    }
  },
  mutations: {
    updateField,
    iniciar (state, payload) {
      if (state.suporteReconhecimento) {
        const ptBr = 'pt-BR'
        artyom.ArtyomProperties.lang = ptBr
        state.emExecucao = false
        state.editor = payload
        state.continuar = true
        state.voz.lang = ptBr
        state.voz.interimResults = true
        state.voz.onresult = (event) => {
          const texto = Array.from(event.results).map(result => result[0]).map(result => result.transcript).join('')
          state.textoTemp = texto
        }
        state.voz.onend = () => {
          if (state.textoTemp !== '') {
            state.frases.push(state.textoTemp)
            state.texto = ` ${state.frases.slice(-1)[0]}`
            inserirTexto(state)
            /*
            const validarComandos = state.texto
            if (validarComandos.match(/(auto(-)? ?texto)/gmi)) {
              artyom.simulateInstruction(validarComandos)
            }
            */
            artyom.simulateInstruction(state.texto)
          }
          state.textoTemp = ''
          state.voz.stop()
          if (state.continuar) {
            state.voz.start()
          }
        }
        state.voz.onaudiostart = () => {
          state.emExecucao = true
          state.inicioPorAtalho = true
        }
        state.voz.start()
      }
    },
    encerrar (state) {
      state.continuar = false
      state.emExecucao = false
      state.inicioPorAtalho = false
      state.voz.stop()
    },
    SET_DICIONARIO (state, payload) {
      state.dicionario = payload
    }
  }
}
